import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import {
    JDJumpingApp,
    JDRouter
} from '@jdreact/jdreact-core-lib';

import reducer from './reducer/root_reducer';

// import Router from './common/router';

import Index from './page/index';
import MovieList from './page/movie-list';
import MovieDetail from './page/movie-detail';
import MovieSchedule from './page/movie-schedule';
import MovieEvaluation from './page/movie-evaluation';
import Seat from './page/seat-selection';
import Order from './page/order';
import AllMovie from './page/all-movie';
import Search from './page/search';
// import MovieCinemaSearch from './page/movie-cinema-search';
import RelatedCinema from './page/related-cinema';
import City from './page/city';
import OrderList from './page/order-list';
import OrderDetail from './page/order-detail';
// import OrderAddr from './components/orderDetail/order-addr';
// import Result from './page/result';
import HistoryList from './page/history';
import Movie from './page/movie';
import Login from './page/login';
import MovieCardList from './page/movie-card/list';
import MovieCardInfo from './page/movie-card/info';
import Activity from './page/activity';
import Error from './page/error';
import YingDouList from './page/yingdou-list';
import refundChange from './page/protocol/refund-change';
import { getLBS } from '@ltfe/ltfe-core-lib/lib/utiles';

import { getClientVersion } from './common/utils';

getClientVersion();
const {
    Router,
    Route
} = JDRouter;

const store = createStore(
    reducer,
    applyMiddleware(thunk)
);

class JDReactMovie extends React.Component {
    render() {
        /* 分享跳转默认页 获取props */

        /**
         * 路由名称 【对外链接列表】 2018/11/14
         * movieDetail 影片详情    入参 movieId collection(1 为收藏该影片)
         * movieSchedule 影院详情  入参 movieId cityId
         * orderList 订单列表      入参 无
         * orderDetail 订单详情    入参 erpOrderId
         * movieList 影片场次列表  入参 cinemaId
         * wangailin@jd.com
         */
        const { routerName } = this.props;

        // 路由参数 all
        const {
            curType,
            movieId,
            erpOrderId,
            cinemaId,
            cityId,
            collection,
            // 电竞通天塔页面需要使用三方协议唤起选座位;
            // 选座需要这些参数;
            planId,
            title,
            movieName,
            theDate,
            startTime,
            playType,
            hallName,
            promtId,
            scheduledPlay,
            scheduledType,
            cityPy,
            cityName,
            fullCityPy,
            from,
            trailerId
        } = this.props;

        //  * channel 渠道 默认2 * buyFrom 来源 默认1

        // 获取当前页面的 URL
        const url = new URL(window.location.href);
        const buyFrom = url?.searchParams?.get('buyFrom') || 9;
        const channel = url?.searchParams?.get('channel') || 1;

        sessionStorage.setItem('buyFrom', buyFrom?.toString());
        sessionStorage.setItem('channel', channel?.toString());

        console.log(buyFrom, channel, cinemaId);

        // 清除开场提示的存储信息
        global.openingHintStorage.remove({
            key: 'openningHintStatus'
        });

        const initRoute = {
            key: routerName || 'index',
            // key: routerName || 'yingdouList',
            routeParams: {
                curType,
                movieId,
                erpOrderId,
                cinemaId,
                cityId,
                collection,
                buyFrom,
                channel,
                planId,
                title,
                movieName,
                theDate,
                startTime,
                playType,
                hallName,
                promtId,
                scheduledPlay,
                scheduledType,
                cityPy,
                cityName,
                fullCityPy,
                from,
                trailerId
            }
        };

        return (
            <Provider store={ store }>
                <Router initRoute={ initRoute } >
                    <Route key='index' component={ Index } />
                    <Route key='movieSchedule' component={ MovieSchedule } />
                    <Route key='movieEvaluation' component={ MovieEvaluation } />
                    <Route key='search' component={ Search } />
                    {/* <Route key='movieCinemaSearch' component={ MovieCinemaSearch } /> */}
                    <Route key='relatedCinema' component={ RelatedCinema } />
                    <Route key='allMovie' component={ AllMovie } />
                    <Route key='movieList' component={ MovieList } />
                    <Route key='movieDetail' component={ MovieDetail } />
                    <Route key='city' component={ City } />
                    <Route key='seat' component={ Seat } />
                    <Route key='order' component={ Order } />
                    <Route key='orderList' component={ OrderList } />
                    <Route key='orderDetail' component={ OrderDetail } />
                    {/* <Route key='orderAddr' component={ OrderAddr } /> */}
                    {/* <Route key='result' component={ Result } /> */}
                    <Route key='history' component={ HistoryList } />
                    <Route key='movie' component={ Movie } />
                    <Route key='login' component={ Login } />
                    <Route key='movieCardList' component={ MovieCardList } />
                    <Route key='movieCardInfo' component={ MovieCardInfo } />
                    <Route key='activity' component={ Activity } />
                    <Route key='error' component={ Error } />
                    <Route key='yingdouList' component={ YingDouList } />
                    <Route key='refundChange' component={ refundChange } />
                </Router>
            </Provider>
        );
    }

    componentDidMount() {
        // if (is_web) {
        this.getPosition();
        //     JSSDK.WxShare.customShare({
        //         title: '京东电影超值购票',
        //         content: '我在京东电影发现超值电影，快来看看吧！',
        //         shareUrl: weixin_share_url, // 微信分享写死为首页地址
        //         iconUrl: 'https://storage.jd.com/ltmovie/movieLogo.jpg'
        //     });
        // }
        setTimeout(() => {
            try {
                JDJumpingApp.autoOpenApp({
                    inteneUrlParams: { des: 'jdreactcommon', transparentenable: true, modulename: 'JDReactMovie', appname: 'JDReactMovie', skuId: '', category: 'jump', param: {} },
                    NoJumpDownLoadPage: 'false'
                });
            } catch (e) {
                console.log(e);
            }
            this.openConsole();
        }, 500);
    }

    // 开启 console 显示
    openConsole() {
        // const vConsole = new window.VConsole();
        // console.log('vConsole', vConsole);
    }

    getPosition = async() => {
        try {
            const { lon, lat } = await getLBS();

            store.dispatch({
                type: 'lbs',
                lbs: { lon, lat }
            });
        } catch (e) {
            console.log('定位失败', e);
        }
    }
}

module.exports = JDReactMovie;
